import {
    styled,
    experimental_sx as sx,
} from '@mui/system';
import Typography from '@mui/material/Typography';

const BigLabel = styled(Typography)(({ theme }) => theme.unstable_sx({
    fontSize: {
        xs: 30,
        md: 32
    },
    fontWeight: 600,
    width: '100%',
    pt: 2,
    pb: 1,
    color: 'text.secondary',
    textAlign: 'center'
}));


export default BigLabel;